<div
	[formGroup]="recurringForm"
	class="p-5 m-auto border theme-main-border-color border-1 card"
>
	<div class="container">
		<div class="row">
			<div class="row mb-1 fw-bold theme-main-color">
				<label>Intervalle de date où l'événement récurrent sera appliqué</label>
			</div>
		</div>

		<div class="row">
			<div class="col">
				<div class="form-inline mb-2">
					<div class="row">
						<input
							name="datepicker"
							class="form-control hidden"
							formControlName="datesForm"
							bsDaterangepicker
							outsideDays="hidden"
							#datepicker="bsDaterangepicker"
							[bsConfig]="{ dateInputFormat: 'dd-MM-YYYY' }"
						/>
					</div>

					<div class="row">
						<div class="col-lg-2">
							<button
								class="btn theme-main-color-button"
								(click)="datepicker.toggle()"
								type="button"
							>
								<i class="bi bi-calendar-event-fill" aria-hidden="true"></i>
							</button>
						</div>
						<div class="col-lg-5">
							<div class="row mt-2">
								<span class="theme-main-color col">Début : </span>
								<span class="theme-main-color col">{{
									f['datesForm'].value[0] | date: 'dd/MM/YYYY'
								}}</span>
							</div>
						</div>
						<div class="col-lg-5">
							<div class="row mt-2">
								<span class="col theme-main-color">Fin : </span>
								<span class="col theme-main-color">{{
									f['datesForm'].value[1] | date: 'dd/MM/YYYY'
								}}</span>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div class="row my-3">
			<div class="col">
				<div class="row mb-1">
					<label class="fw-bold theme-main-color">Répétition</label>
				</div>
			</div>
			<div class="col-lg-4">
				<div class="form-check form-switch">
					<input
						class="form-check-input theme-main-border-color"
						[ngClass]="{ 'theme-main-color-check': customization }"
						type="checkbox"
						id="personaliser"
						[checked]="customization"
						(change)="personalize()"
						disabled
					/>
					<label class="form-check-label theme-main-color" for="personaliser">
						Personalisée
					</label>
				</div>
			</div>
		</div>

		<div class="row">
			<div class="col-lg">
				<div class="form-check form-check-inline">
					<input
						class="form-check-input theme-main-border-color theme-radio-main-color"
						type="radio"
						id="daily"
						formControlName="frequency"
						(change)="generaliser()"
						[value]="Frequency.DAILY"
					/>
					<label class="form-check-label theme-main-color" for="daily">
						Quotidienne
					</label>
				</div>

				<div class="form-check form-check-inline">
					<input
						class="form-check-input theme-main-border-color theme-radio-main-color"
						type="radio"
						id="weekly"
						checked
						formControlName="frequency"
						(change)="generaliser()"
						[value]="Frequency.WEEKLY"
					/>
					<label class="form-check-label theme-main-color" for="weekly">
						Hebdomadaire
					</label>
				</div>

				<div class="form-check form-check-inline">
					<input
						class="form-check-input theme-main-border-color theme-radio-main-color"
						type="radio"
						id="monthly"
						formControlName="frequency"
						(change)="generaliser()"
						[value]="Frequency.MONTHLY"
					/>
					<label class="form-check-label" for="monthly"> Mensuelle </label>
				</div>
			</div>
		</div>

		<hr *ngIf="f.frequency.value !== Frequency.DAILY" />

		<ng-container *ngIf="f.frequency.value === Frequency.DAILY">
			<div class="form-check form-switch">
				<input
					type="checkbox"
					class="form-check-input theme-main-border-color"
					id="weekendActiveSwitchR"
					[ngClass]="{ 'theme-main-color-check': !isWeekendActiveR }"
					[checked]="!isWeekendActiveR"
					(change)="changeWeekendSwitch()"
				/>
				<label class="form-check-label" for="weekendActiveSwitchR"
					>Semaine ouvrée</label
				>
			</div>
		</ng-container>

		<ng-container *ngIf="f.frequency.value === Frequency.WEEKLY">
			<div class="row mb-1">
				<label class="fw-bold theme-main-color"
					>Répétés pour les jours suivants</label
				>
			</div>
			<div
				[ngClass]="{
					'btn-group btn-group-sm btn-group-toggle mb-2': !isMobile,
					'm-2': isMobile
				}"
				formArrayName="onWeekday"
			>
				<input
					type="checkbox"
					class="btn-check"
					id="btn-outlined-0"
					formControlName="0"
				/>
				<label class="btn theme-main-color-btn-outline" for="btn-outlined-0"
					>Lundi</label
				>

				<input
					type="checkbox"
					class="btn-check"
					id="btn-outlined-1"
					formControlName="1"
				/>
				<label class="btn theme-main-color-btn-outline" for="btn-outlined-1"
					>Mardi</label
				>

				<input
					type="checkbox"
					class="btn-check"
					id="btn-outlined-2"
					formControlName="2"
				/>
				<label class="btn theme-main-color-btn-outline" for="btn-outlined-2"
					>Mercredi</label
				>

				<input
					type="checkbox"
					class="btn-check"
					id="btn-outlined-3"
					formControlName="3"
				/>
				<label class="btn theme-main-color-btn-outline" for="btn-outlined-3"
					>Jeudi</label
				>

				<input
					type="checkbox"
					class="btn-check"
					id="btn-outlined-4"
					formControlName="4"
				/>
				<label class="btn theme-main-color-btn-outline" for="btn-outlined-4"
					>Vendredi</label
				>

				<input
					type="checkbox"
					class="btn-check"
					id="btn-outlined-5"
					formControlName="5"
				/>
				<label class="btn theme-main-color-btn-outline" for="btn-outlined-5"
					>Samedi</label
				>

				<input
					type="checkbox"
					class="btn-check"
					id="btn-outlined-6"
					formControlName="6"
				/>
				<label class="btn theme-main-color-btn-outline" for="btn-outlined-6"
					>Dimanche</label
				>
			</div>
		</ng-container>

		<ng-container *ngIf="f.frequency.value === Frequency.MONTHLY">
			<div class="row">
				<label class="fw-bold theme-main-color" for="onMonthday"
					>Date à répéter</label
				>
				<div class="input-group">
					<button
						type="button"
						class="btn theme-main-color-full-button"
						(click)="d.toggle()"
					>
						Sélection date à répéter
					</button>
					<input
						id="onMonthday"
						class="form-control theme-main-color theme-main-border-color"
						placeholder="dd/mm/yyyy"
						name="dp"
						formControlName="onMonthday"
						bsDatepicker
						#d="bsDatepicker"
					/>
				</div>
			</div>
		</ng-container>

		<hr *ngIf="f.frequency.value !== Frequency.DAILY" />

		<div class="row">
			<div class="form-control-plaintext">
				<p class="fw-bold theme-main-color">
					Nombre d'occurrences : {{ dates.length }}
				</p>
				<p>
					<span class="fw-bold theme-main-color">Dates : </span>
					<span
						class="d-inline-block bg-light rounded border border-1 theme-main-border-color thumbnail m-1"
						*ngFor="let date of dates"
					>
						<span class="dateaffiche m-2 theme-main-color">{{
							date | date: 'dd/MM/yyyy'
						}}</span>
						<button
							class="monbuton btn-sm btn-danger"
							(click)="supprimer(date)"
						>
							Supprimer
						</button>
					</span>
				</p>
			</div>
		</div>
	</div>
</div>
